/**
 * @typedef {{ prefix: string|null, route: string, type: 'navigated' }} NavigationEventDetail
 * @typedef {CustomEvent<NavigationEventDetail>} SynapseNavigationEvent
 */
/**
 * Navigates the UI frame to /prefix/route
 * @param {string} route
 * @param {string} [prefix]
 * @param {EventTarget} [target]
 */
export function navigate(route, prefix = null, target = window) {
    target.dispatchEvent(new CustomEvent('synapse-app-event', {
        detail: /** @type {NavigationEventDetail} */ ({
            type: 'navigated',
            prefix,
            route,
        }),
        bubbles: true,
        composed: true,
    }));
}
/**
 * If the previous page is in UI Frame, navigates back, if not, then goes to the fallback route
 * @param {string} fallbackRoute
 * @param {EventTarget} [target]
 */
export function navigateBack(fallbackRoute = '', target = window) {
    target.dispatchEvent(new CustomEvent('synapse-app-event', {
        detail: /** @type {NavigationEventDetail} */ ({
            type: 'navigated-back',
            fallbackRoute,
        }),
        bubbles: true,
        composed: true,
    }));
}
/**
 * Opens a link in a new tab
 * @param {string} link
 * @param {Navigator} navigatorInstance
 */
export function openNewTab(link, navigatorInstance = window.navigator) {
    if (!navigatorInstance.userAgent.includes('NativeTechnicianConsole')) {
        window.open(link, '_blank');
    }
    else {
        openNewTabInDesktopConsole(link);
    }
}
/**
 * Opens a link in a new tab in Desktop Console
 * @param {string} link
 */
export function openNewTabInDesktopConsole(link) {
    window.dispatchEvent(new CustomEvent('synapse-app-event', {
        detail: { type: 'integration-event', event: { type: 'open-link', link }, exposed: true },
        bubbles: true,
        composed: true,
    }));
}
